import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {MatProgressBarModule} from '@angular/material/progress-bar';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { AnswerComponent } from './answer/answer.component';
import { Service } from './service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { QuestionComponent } from './question/question.component';
import { HomeComponent } from './home/home.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { FormComponent } from './form/form.component';
import { ReportComponent } from './report/report.component';
import {GoogleAnalyticsService} from './google-analytics.service';





@NgModule({
  declarations: [
    AppComponent,
    QuestionComponent,
    HomeComponent,
    AnswerComponent,
    PageNotFoundComponent,
    FormComponent,
    ReportComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MatProgressBarModule,
    FormsModule 
  ],
  providers: [Service,GoogleAnalyticsService],
  bootstrap: [AppComponent]
})
export class AppModule { }
